import { ChildrenStoreData } from "src/shared/types/src";
import { getAxiosInstance } from "../api";
import { API_PART_URL } from "src/shared/config/src";
import { LinkTFCPayloadType, TFCPaymentRequestType, UnlinkTFCPayloadType } from "src/shared/types/src/lib/invoice.types";

export const getInvoices = async ({ child }: { child: ChildrenStoreData }): Promise<any> => {
    const { retryAxios } = getAxiosInstance();
    return retryAxios.get(`${child.instanceUrl}${API_PART_URL}/v2/child/${child.childId}/transactions`).then((res) => {
        const response = res.data;
        if (response && response.status === "success") {
            return response.data;
        }
        return null;
    });
};

export const getAccountSummary = async ({ child }: { child: ChildrenStoreData }): Promise<any> => {
    const { retryAxios } = getAxiosInstance();
    return retryAxios.get(`${child.instanceUrl}${API_PART_URL}/v2/child/${child.childId}/account-summary`).then((res) => {
        const response = res.data;
        if (response && response.status === "success") {
            return response.data;
        }
        return null;
    });
};

export const payAmount = async (
    { child, amount = '0.00', deposit = '0.00', total = '0.00', invoiceId = '' }:
        { child: ChildrenStoreData, amount: string, deposit: string, total: string, invoiceId?: string }
): Promise<any> => {
    const { retryAxios } = getAxiosInstance();
    const payload = {
        type: "balance",
        params: {
            amount: Number(amount),
            deposit: Number(deposit),
            total: Number(total),
            invoiceId
        }
    }

    return retryAxios.post(`${child.instanceUrl}${API_PART_URL}/child/${child.childId}/payment`, payload).then((res) => {
        const response = res.data;
        if (response && response.status === "success") {
            return response.data;
        }
        return null;
    });
};

// API to get the HMRC OAuth URL
export const generateHMRCAuthUrl = async (): Promise<any> => {
    const { retryAxios } = getAxiosInstance();
    return retryAxios.get('/user/tfc/generate-auth-url', { params: { useAccessToken: true } }).then((res) => {
        const response = res.data;
        console.log("response from tfc auth url api : ", JSON.stringify(response, null, 2));
        if (response && response.status === "success") {
            return response.data;
        }
        return null;
    });
}

// API to fetch available payment methods on this nursery
export const getPaymentMethodsOnNursery = async ({ child, nurseryId }: { child: ChildrenStoreData, nurseryId: string }): Promise<any> => {
    const { retryAxios } = getAxiosInstance();
    return retryAxios.get(`${child.instanceUrl}${API_PART_URL}/nursery/${nurseryId}/payment-methods`).then((res) => {
        const response = res.data;
        if (response && response.status === "success") {
            return response.data;
        }
        return null;
    });
}

// API to check auth status of HMRC for a parent
export const validateHMRCAuthSession = async (): Promise<any> => {
    const { retryAxios } = getAxiosInstance();
    return retryAxios.get('/user/tfc/check-permission', { params: { useAccessToken: true } }).then((res) => {
        const response = res.data;
        console.log("response from tfc check permission api : ", JSON.stringify(response, null, 2));
        if (response && response.status === "success") {
            return response.data;
        }
        return null;
    });
}

// API to send Link TFC request
export const linkTFCAccounts = async (
    { child, payload }: { child: ChildrenStoreData, payload: LinkTFCPayloadType[] }
): Promise<any> => {
    const { retryAxios } = getAxiosInstance();
    return retryAxios.patch(`${child.instanceUrl}${API_PART_URL}/nursery/${child?.nursery?.eymanNurseryId}/tfc/link-account`, payload).then((res) => {
        const response = res.data;
        if (response && response.status === "success") {
            return response.data;
        }
        return null;
    });
};

// API to unlink a TFC account for a child
export const unlinkTFCAccountForChild = async (
    { child, payload }: { child: ChildrenStoreData, payload: UnlinkTFCPayloadType }
): Promise<any> => {
    const { retryAxios } = getAxiosInstance();
    return retryAxios.patch(`${child.instanceUrl}${API_PART_URL}/nursery/${child?.nursery?.eymanNurseryId}/tfc/unlink-account`, payload).then((res) => {
        const response = res.data;
        console.log("response from unlink api : ", JSON.stringify(response, null, 2));
        if (response && response.status === "success") {
            return response.data;
        }
        return null;
    });
};

// API to fetch TFC balance of the parent
export const getTFCBalance = async ({ child, noCache }: { child: ChildrenStoreData, noCache: boolean }): Promise<any> => {
    const { retryAxios } = getAxiosInstance();
    const queryString = noCache ? `?noCache=${noCache}` : '';
    return retryAxios.get(`${child.instanceUrl}${API_PART_URL}/child/${child.childId}/tfc/check-balance${queryString}`).then((res) => {
        const response = res.data;
        if (response && response.status === "success") {
            return response.data;
        }
        return null;
    });
}

// API to send a TFC payment request
export const postTFCPayment = async ({ child, payload }: { child: ChildrenStoreData, payload: TFCPaymentRequestType }): Promise<any> => {
    const { retryAxios } = getAxiosInstance();
    console.log("payload : ", payload)
    return retryAxios.post(`${child.instanceUrl}${API_PART_URL}/child/${child.childId}/tfc/payment`, { ...payload }).then((res) => {
        const response = res.data;
        if (response && response.status === "success") {
            return response.data;
        }
        return null;
    });
}